var map = {
	"./chevron-down.svg": 2431,
	"./edit-2.svg": 9728,
	"./investor-arrow.svg": 8525,
	"./investor-icon.svg": 6733,
	"./manager-arrow.svg": 7742,
	"./page-header.svg": 8510,
	"./profile-2user.svg": 8468,
	"./talent-arrow.svg": 5151,
	"./talent-icon.svg": 6639,
	"./user-tag.svg": 8291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5504;